import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-12 px-3 py-2"
}
const _hoisted_4 = {
  key: 1,
  class: "badge bg-warning-subtle text-warning fs-12 px-3 py-2"
}
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4 p-3 rounded-3 bg-light border border-light-subtle"
}
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_8 = { class: "fw-bold text-primary mb-0" }
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "row g-2 fs-13" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "fw-bold text-dark ms-1" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "fw-bold text-dark ms-1" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-md-4 mb-2" }
const _hoisted_23 = { class: "col-md-4 mb-2" }
const _hoisted_24 = { class: "col-md-4 mb-2" }
const _hoisted_25 = { class: "row mb-3" }
const _hoisted_26 = { class: "col-md-6 mb-2" }
const _hoisted_27 = { class: "col-md-6 mb-2" }
const _hoisted_28 = { class: "p-3 bg-light rounded-2 mb-3 border" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-3 mb-2" }
const _hoisted_31 = { class: "col-md-3 mb-2" }
const _hoisted_32 = { class: "col-md-3 mb-2" }
const _hoisted_33 = { class: "col-md-3 mb-2" }
const _hoisted_34 = { class: "col-md-6 mb-2" }
const _hoisted_35 = { class: "col-md-6 mb-2" }
const _hoisted_36 = { class: "p-3 bg-light-subtle rounded-2 mb-3 border" }
const _hoisted_37 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "col-md-2" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { class: "col-md-2 d-flex align-items-center gap-1" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = { class: "col-md-4 mb-2" }
const _hoisted_51 = { class: "col-md-4 mb-2" }
const _hoisted_52 = { class: "col-md-4 mb-2" }
const _hoisted_53 = { class: "col-12 mt-2" }
const _hoisted_54 = { class: "form-check" }
const _hoisted_55 = { class: "d-flex justify-content-end gap-2 mt-4" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "smart_toy"),
        _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Protokol Uji Deteksi AI (SOP RBN/SOP-RC/AI/001)")
      ], -1)),
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.protocol.protocol_number), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, " Belum Dibuat "))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-muted fs-12" }, "Nomor Protokol Resmi", -1)),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.protocol.protocol_number), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePdf && _ctx.generatePdf(...args))),
                  disabled: _ctx.generatingPdf,
                  class: "btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                }, [
                  (_ctx.generatingPdf)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("", true),
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "picture_as_pdf", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.generatingPdf ? 'Membuat PDF...' : 'Regenerate PDF Protokol'), 1)
                ], 8, _hoisted_10),
                (_ctx.order.generated_protocol_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.getFileUrl(_ctx.order.generated_protocol_pdf),
                      target: "_blank",
                      class: "btn btn-sm btn-success d-flex align-items-center gap-1"
                    }, _cache[23] || (_cache[23] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "download", -1),
                      _createElementVNode("span", null, "Unduh Dokumen Resmi A4", -1)
                    ]), 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.protocol.verification?.verification_code)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getVerificationUrl(_ctx.protocol.verification.verification_code),
                      target: "_blank",
                      class: "btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                    }, _cache[24] || (_cache[24] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "verified", -1),
                      _createElementVNode("span", null, "Cek Verifikasi Publik", -1)
                    ]), 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-muted" }, "Skor Deteksi AI:", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.protocol.ai_score_initial) + "% → " + _toDisplayString(_ctx.protocol.ai_score_final) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-muted" }, "Zona Deteksi:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.ai_score_final <= _ctx.protocol.applied_threshold ? 'bg-success' : 'bg-warning'])
                }, _toDisplayString(_ctx.protocol.internal_zone), 3)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-muted" }, "Status:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.status_code === 'PASS' ? 'bg-success' : 'bg-danger'])
                }, _toDisplayString(_ctx.protocol.status_code), 3)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-muted" }, "Total Run Siklus:", -1)),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.protocol.total_runs_count) + " Run", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProtocol && _ctx.saveProtocol(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Perangkat AI Detector "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.detector_name) = $event)),
              required: "",
              placeholder: "Turnitin AI / GPTZero"
            }, null, 512), [
              [_vModelText, _ctx.form.detector_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Versi Perangkat", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.detector_version) = $event)),
              placeholder: "2026 Model Release"
            }, null, 512), [
              [_vModelText, _ctx.form.detector_version]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Bahasa Naskah "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.document_language) = $event)),
              required: "",
              placeholder: "Bahasa Indonesia / English"
            }, null, 512), [
              [_vModelText, _ctx.form.document_language]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Lingkup Teks Dianalisis", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.analyzed_scope) = $event)),
              required: "",
              placeholder: "Seluruh bab naskah utama (abstrak s.d. kesimpulan)"
            }, null, 512), [
              [_vModelText, _ctx.form.analyzed_scope]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Lingkup Dikecualikan", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.excluded_scope) = $event)),
              placeholder: "Daftar pustaka, lampiran, ucapan terima kasih"
            }, null, 512), [
              [_vModelText, _ctx.form.excluded_scope]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "fw-bold fs-13 mb-2 text-dark" }, "Ambang Batas & Pengukuran Skor AI (SOP RBN)", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label fs-12" }, "Ambang Batas Maks. (%)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.applied_threshold) = $event)),
                onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateZone && _ctx.updateZone(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.form.applied_threshold]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Skor AI Awal / Run 1 (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.ai_score_initial) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.ai_score_initial]
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Skor AI Akhir (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.ai_score_final) = $event)),
                onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateZone && _ctx.updateZone(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.form.ai_score_final]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label fs-12" }, "Zona Internal RBN", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.internal_zone) = $event)),
                required: ""
              }, _cache[37] || (_cache[37] = [
                _createElementVNode("option", { value: "Rendah (0-20%)" }, "Rendah (0-20%)", -1),
                _createElementVNode("option", { value: "Dalam Batas (21-40%)" }, "Dalam Batas (21-40%)", -1),
                _createElementVNode("option", { value: "Melebihi Batas (41-60%)" }, "Melebihi Batas (41-60%)", -1),
                _createElementVNode("option", { value: "Signifikan (>60%)" }, "Signifikan (>60%)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.internal_zone]
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Status Kode Keputusan "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.status_code) = $event)),
                required: ""
              }, _cache[39] || (_cache[39] = [
                _createElementVNode("option", { value: "PASS" }, "PASS (Memenuhi Syarat)", -1),
                _createElementVNode("option", { value: "REVISE" }, "REVISE (Perlu Revisi Penulis/Editor)", -1),
                _createElementVNode("option", { value: "CLARIFY" }, "CLARIFY (Perlu Klarifikasi)", -1),
                _createElementVNode("option", { value: "ESCALATE" }, "ESCALATE (Eskalasi ke Head QC)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.status_code]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label fs-12" }, "Total Siklus Run", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.total_runs_count) = $event)),
                min: "1"
              }, null, 512), [
                [_vModelText, _ctx.form.total_runs_count]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "fw-bold fs-13 text-dark" }, "Matriks Review Per Bab / Bagian Naskah", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addSectionReview && _ctx.addSectionReview(...args))),
              class: "btn btn-xs btn-outline-primary btn-sm fs-11"
            }, " + Tambah Bab ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.section_reviews, (sec, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "row g-2 mb-2 p-2 bg-white rounded border align-items-center"
            }, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((sec.section_name) = $event),
                  placeholder: "Bab / Bagian..."
                }, null, 8, _hoisted_39), [
                  [_vModelText, sec.section_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((sec.page_range) = $event),
                  placeholder: "Hlm 1-5"
                }, null, 8, _hoisted_41), [
                  [_vModelText, sec.page_range]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((sec.indicator_score) = $event),
                  placeholder: "Indikator AI..."
                }, null, 8, _hoisted_43), [
                  [_vModelText, sec.indicator_score]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((sec.context_note) = $event),
                  placeholder: "Catatan konteks..."
                }, null, 8, _hoisted_45), [
                  [_vModelText, sec.context_note]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((sec.action) = $event)
                }, _cache[44] || (_cache[44] = [
                  _createElementVNode("option", { value: "No action" }, "No action", -1),
                  _createElementVNode("option", { value: "Review" }, "Review", -1),
                  _createElementVNode("option", { value: "Revise" }, "Revise", -1),
                  _createElementVNode("option", { value: "Clarify" }, "Clarify", -1)
                ]), 8, _hoisted_47), [
                  [_vModelSelect, sec.action]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeSectionReview(idx)),
                  class: "btn btn-link text-danger p-0"
                }, _cache[45] || (_cache[45] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                ]), 8, _hoisted_48)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Nama Penulis (Masked)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.author_name_masked) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.author_name_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Judul Naskah (Masked)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.document_title_masked) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.document_title_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Examiner AI", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.examiner_name) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.examiner_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.disclaimer_agreed) = $event)),
                id: "discCheck",
                required: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.disclaimer_agreed]
              ]),
              _cache[49] || (_cache[49] = _createElementVNode("label", {
                class: "form-check-label fs-12 text-secondary",
                for: "discCheck"
              }, " Saya menyetujui Disclaimer Akademik Resmi RBN bahwa deteksi AI bersifat probabilistik dan telah diverifikasi secara manual. ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary px-4 py-2 d-flex align-items-center gap-2",
            disabled: _ctx.submitting
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_57))
              : _createCommentVNode("", true),
            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "save", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.protocol ? 'Perbarui Protokol' : 'Simpan & Terbitkan Protokol RC-AI'), 1)
          ], 8, _hoisted_56)
        ])
      ], 32)
    ])
  ]))
}